import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import socket from '../socket';

function Join() {
  const navigate = useNavigate();
  const { roomCode: urlRoomCode } = useParams();
  const [playerName, setPlayerName] = useState('');
  const [roomCode, setRoomCode] = useState(urlRoomCode || '');
  const [mode, setMode] = useState(urlRoomCode ? 'join' : null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreate = () => {
    if (!playerName.trim()) {
      setError('Bitte gib einen Namen ein');
      return;
    }
    setLoading(true);
    setError('');

    // Disconnect any existing connection
    socket.disconnect();

    // Connect creates the lobby via WebSocket
    socket.on('connected', (data) => {
      socket.off('connected');
      socket.off('error');
      setLoading(false);
      navigate(`/lobby/${data.roomCode}`);
    });

    socket.on('error', (data) => {
      socket.off('connected');
      socket.off('error');
      setLoading(false);
      setError(data.error || 'Lobby konnte nicht erstellt werden');
    });

    socket.connect({ action: 'create', name: playerName.trim() });
  };

  const handleJoin = () => {
    if (!playerName.trim()) {
      setError('Bitte gib einen Namen ein');
      return;
    }
    if (!roomCode.trim()) {
      setError('Bitte gib einen Raum-Code ein');
      return;
    }
    setLoading(true);
    setError('');

    // Disconnect any existing connection
    socket.disconnect();

    socket.on('connected', (data) => {
      socket.off('connected');
      socket.off('error');
      setLoading(false);
      navigate(`/lobby/${data.roomCode}`);
    });

    socket.on('error', (data) => {
      socket.off('connected');
      socket.off('error');
      setLoading(false);
      setError(data.error || 'Beitreten fehlgeschlagen');
    });

    socket.connect({ action: 'join', room: roomCode.trim().toUpperCase(), name: playerName.trim() });
  };

  return (
    <div className="join-page">
      <div className="join-container">
        <h1 className="page-title">
          <span className="back-btn" onClick={() => navigate('/')}>←</span>
          Multiplayer
        </h1>

        {!mode && (
          <div className="join-choice">
            <button className="btn btn-primary btn-large" onClick={() => setMode('create')}>
              Neue Lobby erstellen
            </button>
            <div className="divider"><span>oder</span></div>
            <button className="btn btn-secondary btn-large" onClick={() => setMode('join')}>
              Lobby beitreten
            </button>
          </div>
        )}

        {mode && (
          <div className="join-form">
            <div className="form-group">
              <label>Dein Name</label>
              <input
                type="text"
                placeholder="Name eingeben..."
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                maxLength={20}
                autoFocus
              />
            </div>

            {mode === 'join' && (
              <div className="form-group">
                <label>Raum-Code</label>
                <input
                  type="text"
                  placeholder="Z.B. ABC123"
                  value={roomCode}
                  onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                  maxLength={6}
                  className="room-code-input"
                />
              </div>
            )}

            {error && <div className="error-message">{error}</div>}

            <button
              className="btn btn-primary btn-large"
              onClick={mode === 'create' ? handleCreate : handleJoin}
              disabled={loading}
            >
              {loading ? 'Laden...' : mode === 'create' ? 'Lobby erstellen' : 'Beitreten'}
            </button>

            <button className="btn btn-ghost" onClick={() => setMode(null)}>
              Zurück
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Join;
